import React from "react";

import { makeStyles } from "@material-ui/core/styles";

import { Grid } from "@material-ui/core";

import StackGhostBg from "../../../assets/stackGhost/StakeGhostBg.svg";
import StakeGhostBgVector1 from "../../../assets/stackGhost/StakeGhostBgVector1.svg";
import StakeGhostBgVector2 from "../../../assets/stackGhost/StakeGhostBgVector2.svg";
import StackLeftSide from "./StackLeftSide";
import StackRightSide from "./StackRightSide";

const useStyles = makeStyles((theme) => ({
  body: {
    paddingTop: 100,
    position: "relative",
    [theme.breakpoints.down("xs")]: {
      paddingTop: 35,
    },
  },
  mainarea: {
    [theme.breakpoints.up("md")]: {
      backgroundImage: `url(${StackGhostBg})`,
      backgroundSize: "cover",
      backgroundRepeat: "no-repeat",
    },
  },
  mainContainer: {
    paddingTop: 200,
    position: 'relative',
    paddingBottom: 0,
    [theme.breakpoints.down("xs")]: {
      paddingTop: 0,
      paddingBottom: 0,
    },
    [theme.breakpoints.down("sm")]: {
      paddingTop: 0,
      paddingBottom: 0,
    },
  },
  StakeGhostBgVector1: {
    position: "absolute",
    top: 600,
    right: 0,
    [theme.breakpoints.down("sm")]: {
      display: "none",
    },
  },
  StakeGhostBgVector2: {
    position: "absolute",
    top: 690,
    right: 0,
    [theme.breakpoints.down("sm")]: {
      display: "none",
    },
  },
}));

const StackGhost = () => {
  const classes = useStyles();
  return (
    <div className={classes.body}>
      <div className={classes.mainarea}>
        <img
          src={StakeGhostBgVector1}
          alt="Overview"
          className={classes.StakeGhostBgVector1}
        />
        <img
          src={StakeGhostBgVector2}
          alt="Overview"
          className={classes.StakeGhostBgVector2}
        />
        <div className="container">
          <div className="test">
          </div>
          <Grid container className={classes.mainContainer}>
            <Grid item md={12} sm={12} xs={12} style={{marginBottom: 18}}>
              <coingecko-coin-price-marquee-widget coin-ids="ghost-by-mcafee" currency="usd" background-color="#ffffff" locale="en" font-color="#000000"></coingecko-coin-price-marquee-widget>
            </Grid>
            <Grid item md={6} sm={12} xs={12}>
              <StackLeftSide />
            </Grid>
            <Grid item md={6} sm={12} xs={12}>
              <StackRightSide />
            </Grid>
          </Grid>
        </div>
      </div>
    </div>
  );
};

export default StackGhost;
